let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("l7vp6")).then(() => parcelRequire('hJpAP'));